var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _dec48, _dec49, _dec50, _dec51, _dec52, _dec53, _dec54, _dec55, _dec56, _dec57, _dec58, _dec59, _dec60, _dec61, _dec62, _dec63, _dec64, _dec65, _dec66, _dec67, _dec68, _dec69, _dec70, _dec71, _dec72, _dec73, _dec74, _dec75, _dec76, _dec77, _dec78, _dec79, _dec80, _dec81, _dec82, _dec83, _dec84, _dec85, _dec86, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _descriptor64, _descriptor65, _descriptor66, _descriptor67, _descriptor68, _descriptor69, _descriptor70, _descriptor71, _descriptor72, _descriptor73, _descriptor74, _descriptor75, _descriptor76, _descriptor77, _descriptor78, _descriptor79, _descriptor80, _class3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo, hasMany } from '@ember-data/model';
import { getOwner } from '@ember/application';
import { alias, empty, mapBy, sort } from '@ember/object/computed';
import { A } from '@ember/array';
import { isPresent, isNone, isEmpty } from '@ember/utils';
import { computed, set } from '@ember/object';
import { observes } from '@ember-decorators/object';
import { array, fragmentArray } from 'ember-data-model-fragments/attributes';
import { inject as service } from '@ember/service';
import { TEMP_FRACTIONAL_INVENTORY_IN_STOCK_COUNT, TEMP_FRACTIONAL_INVENTORY_AVAILABLE_COUNT } from '@square/dashboard-data/models/catalog/catalog-service-constants';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
import bankersRound from '@square/dashboard-utilities/utils/math/bankers-round';
import Money from '@square/dashboard-money/models/money';
import NumericEnum from '@square/dashboard-utilities/utils/numeric-enum';
import DecimalStockCount from '@square/dashboard-items-data/models/decimal-stock-count';
import { formatMeasurementUnitAbbreviation } from '@square/dashboard-utilities/helpers/format-measurement-unit-abbreviation';
import { CompositionType } from '@square/dashboard-items-data/models/composition';
export const PricingType = NumericEnum.create(['FIXED_PRICING', 'VARIABLE_PRICING']);
export const WeightUnit = NumericEnum.create(['INVALID_WEIGHT', 'IMPERIAL_POUND', 'METRIC_KILOGRAM']);
let _class = (_dec = service(), _dec2 = service(), _dec3 = service(), _dec4 = service(), _dec5 = attr('string'), _dec6 = attr('string-empty-to-null'), _dec7 = attr('number', {
  defaultValue: 1
}), _dec8 = attr('legacy-money'), _dec9 = attr('string'), _dec10 = attr('enum', {
  enumClass: PricingType,
  defaultValue: PricingType.VARIABLE_PRICING
}), _dec11 = fragmentArray('custom-attribute-value'), _dec12 = belongsTo('item', {
  async: false
}), _dec13 = array('string'), _dec14 = attr('legacy-money'), _dec15 = attr('number'), _dec16 = attr('money-proto'), _dec17 = attr('number'), _dec18 = attr('boolean', {
  allowNull: true
}), _dec19 = attr('number'), _dec20 = attr('number'), _dec21 = fragmentArray('resource-membership'), _dec22 = fragmentArray('intermission'), _dec23 = attr('number'), _dec24 = attr('decimal-stock-count'), _dec25 = attr('decimal-stock-count'), _dec26 = attr('decimal-stock-count'), _dec27 = attr('string'), _dec28 = attr('number'), _dec29 = attr('number'), _dec30 = attr('number'), _dec31 = attr('string'), _dec32 = attr('boolean', {
  allowNull: true
}), _dec33 = attr('boolean', {
  allowNull: true
}), _dec34 = attr('string'), _dec35 = attr('boolean', {
  allowNull: true
}), _dec36 = attr('boolean', {
  allowNull: true
}), _dec37 = hasMany('item-variation-vendor-info', {
  async: false
}), _dec38 = hasMany('component', {
  async: false
}), _dec39 = belongsTo('composition', {
  autosaved: ['components'],
  async: false
}), _dec40 = belongsTo('ingredient', {
  async: false
}), _dec41 = belongsTo('recipe', {
  autosaved: ['ingredients'],
  async: false
}), _dec42 = hasMany('salePrice', {
  async: false
}), _dec43 = alias('salePrices.firstObject'), _dec44 = fragmentArray('object-image-membership', {
  relatedType: 'connect/image'
}), _dec45 = array('string', {
  defaultValue: []
}), _dec46 = computed(function () {
  return ['ordinal'];
}), _dec47 = sort('imageMemberships', 'imageSortProperties'), _dec48 = mapBy('sortedImageMemberships', 'image'), _dec49 = alias('images.firstObject'), _dec50 = attr('number'), _dec51 = attr('enum', {
  enumClass: WeightUnit
}), _dec52 = attr('string'), _dec53 = hasMany('credit-redemption-policy', {
  async: false
}), _dec54 = computed('stockable', function () {
  return isNone(this.stockable) || this.stockable;
}), _dec55 = computed('sellable', function () {
  return isNone(this.sellable) || this.sellable;
}), _dec56 = computed('composition.components.@each.{isDeleted,itemVariation}', 'composition.isDeleted', 'id', 'item', function () {
  if (isNone(this.composition)) {
    return false;
  }
  const component = this.composition.components.find(o => o.composition === this.composition);
  if (isNone(component)) {
    return false;
  }
  const sourceVariation = component.itemVariation;
  if (this.composition.isDeleted || this.composition.components.length !== 1 || component.isDeleted || this.item !== sourceVariation.item ||
  // Since stockable is assumed true if missing, we're doing an explicit comparison here
  sourceVariation.stockable === false) {
    return false;
  }
  return true;
}), _dec57 = computed('serviceCostPercentage'), _dec58 = computed('serviceCostFlat.amount', 'price.amount', 'pricingType'), _dec59 = computed('components.@each.{isDeleted,composition}', function () {
  return this.components.filter(component => !component.isDeleted).map(component => {
    if (component.belongsTo('composition').value() !== null) {
      return component.composition.itemVariation;
    }
    return component.itemVariation;
  }).compact()
  // We only care about the non-deleted sell-by variations
  .filter(itemVariation => !itemVariation.isDeleted && itemVariation.isSellByVariation);
}), _dec60 = computed('composition', 'components.@each.{composition,isDeleted}', 'composition.{components,compositionType}', 'composition.components.@each.{[],isDeleted}', function () {
  if (this.composition?.compositionType === 'FIXED_COMPOSITION') {
    const compositionVariations = [];
    this.composition.components.filter(component => !component.isDeleted).forEach(component => compositionVariations.push(component.itemVariation));
    compositionVariations.compact().filter(itemVariation => !itemVariation.isDeleted);
    return compositionVariations;
  }
  return [];
}), _dec61 = computed('recipe.ingredients.@each.isDeleted', function () {
  const ingredientVariations = [];
  this.recipe?.ingredients.filter(ingredient => !ingredient.isDeleted).forEach(ingredient => ingredientVariations.push(ingredient.itemVariation));
  ingredientVariations.compact().filter(itemVariation => !itemVariation.isDeleted);
  return ingredientVariations;
}), _dec62 = computed('isSellable', 'ordinal', 'derivedSellByVariations.@each.{ordinal,sellable}', function () {
  const sellableVariations = [];
  if (this.isSellable) {
    sellableVariations.push(this);
  }
  if (!isEmpty(this.derivedSellByVariations)) {
    sellableVariations.pushObjects(this.derivedSellByVariations);
  }
  return sellableVariations.sortBy('ordinal');
}), _dec63 = computed('sellableVariations', function () {
  return this.sellableVariations.filter(variation => {
    return variation.isSellable;
  });
}), _dec64 = empty('variationsForSale'), _dec65 = hasMany('connect/item-option-value', {
  async: false
}), _dec66 = array('string'), _dec67 = belongsTo('connect/measurement-unit', {
  async: false
}), _dec68 = computed('components.@each.isDirty', 'composition.isDirty', 'dirtyType', 'hasDirtyFields', 'itemVariationVendorInfos.@each.isDirty', 'measurementUnit.isDirty', 'recipe.isDirty', 'salePrices.@each.isDirty'), _dec69 = computed('gtin', 'hasDirtyAttributes', function () {
  return isPresent(this.changedAttributes()['gtin']?.[0]) || isPresent(this.changedAttributes()['gtin']?.[1]);
}), _dec70 = computed('name', 'sku', function () {
  const name = this.name;
  const sku = this.sku;
  const comps = [];
  if (isPresent(name)) {
    comps.push(name);
  }
  if (isPresent(sku)) {
    comps.push(sku);
  }
  return comps.join(', ');
}), _dec71 = computed('_vendorsOverride', 'itemVariationVendorInfos.@each.{isDeleted,vendor}'), _dec72 = computed('_defaultItemVariationVendorInfo', 'itemVariationVendorInfos.@each.{isDeleted,ordinal}'), _dec73 = alias('defaultItemVariationVendorInfo.vendor'), _dec74 = alias('defaultItemVariationVendorInfo.price'), _dec75 = computed('price.amount', 'pricingType', function () {
  return this.pricingType === PricingType.VARIABLE_PRICING || isNone(this.price?.amount);
}), _dec76 = computed('formatter', 'item.totalInclusiveFeesPercentage', 'price.{amount,currencyCode}', function () {
  const totalFeePercentage = this.item?.totalInclusiveFeesPercentage;
  const amountCents = this.price?.amount;
  if (isNone(totalFeePercentage) || isNone(amountCents) || totalFeePercentage === 0 || amountCents === 0) {
    return null;
  }
  const taxCents = bankersRound(amountCents - amountCents * 100 / (100 + totalFeePercentage));
  return this.formatter.currency(taxCents, this.price?.currencyCode);
}), _dec77 = computed('formatter', 'price.{amount,currencyCode}', function () {
  return this.formatter.currency(this.price.amount, this.price.currencyCode);
}), _dec78 = computed('isVariablePriced', 'unitOverrides', 'subunits', function () {
  return this.getPriceRangeForUnits(this.subunits);
}), _dec79 = computed('intl.t', 'isVariablePriced', 'measurementUnit.measurementUnitData.measurementUnit', 'subunits', 'unitOverrides', function () {
  const pricesInfo = this.getPricesInfoForUnits(this.subunits);
  if (!isEmpty(pricesInfo.description)) {
    return pricesInfo.description;
  }
  if (isNone(this.measurementUnit)) {
    if (!isNone(pricesInfo.price)) {
      return pricesInfo.price.formatted;
    } else {
      return this.intl.t('items.displayPrice.range', {
        min: pricesInfo.prices.firstObject.formatted,
        max: pricesInfo.prices.lastObject.formatted
      });
    }
  } else {
    if (!isNone(pricesInfo.price)) {
      return this.intl.t('items.displayPrice.exactMeasurement', {
        price: pricesInfo.price.formatted,
        measurementUnitAbbreviation: formatMeasurementUnitAbbreviation(this.measurementUnit.measurementUnitData.measurementUnit, this.intl),
        htmlSafe: true
      });
    } else {
      return this.intl.t('items.displayPrice.rangeMeasurement', {
        min: pricesInfo.prices.firstObject.formatted,
        max: pricesInfo.prices.lastObject.formatted,
        measurementUnitAbbreviation: formatMeasurementUnitAbbreviation(this.measurementUnit.measurementUnitData.measurementUnit, this.intl),
        htmlSafe: true
      });
    }
  }
}), _dec80 = computed('subunits', 'unitOverrides', function () {
  const tokens = [];
  const unitTokens = this.subunits.mapBy('token');
  unitTokens.forEach(unitToken => {
    if (this.inventoryTrackingAndAlertsEnabledAtSubunit(unitToken) && this.inventoryIsLowAtSubunit(unitToken)) {
      tokens.addObject(unitToken);
    }
  });
  return tokens;
}), _dec81 = computed('subunits', 'unitOverrides', function () {
  const tokens = [];
  const unitTokens = this.subunits.mapBy('token');
  unitTokens.forEach(unitToken => {
    if (this.inventoryTrackingAndAlertsEnabledAtSubunit(unitToken) && this.inventoryIsOutAtSubunit(unitToken)) {
      tokens.addObject(unitToken);
    }
  });
  return tokens;
}), _dec82 = computed('itemOptionValues.@each.itemOptionId', function () {
  const valueMap = new Map();
  (this.itemOptionValues || []).forEach(value => {
    valueMap.set(value.itemOptionId, value);
  });
  return valueMap;
}), _dec83 = observes('price', 'item.isDonation'), _dec84 = computed('unitOverrides', 'effectiveEnabledUnits.@each.unit_token', function () {
  if (isEmpty(this.effectiveEnabledUnits)) {
    return false;
  }
  return this.effectiveEnabledUnits.every(unit => {
    const soldOutValidUntil = this.getUnitOverride(unit.token, 'sold_out_valid_until');
    const soldOutIsValid = isNone(soldOutValidUntil) || new Date(soldOutValidUntil) > new Date();
    return this.getUnitOverride(unit.token, 'sold_out') && soldOutIsValid;
  });
}), _dec85 = computed('unitOverrides', 'effectiveEnabledUnits.@each.unit_token', function () {
  if (isEmpty(this.effectiveEnabledUnits)) {
    return false;
  }
  return this.effectiveEnabledUnits.any(unit => {
    const soldOutValidUntil = this.getUnitOverride(unit.token, 'sold_out_valid_until');
    const soldOutIsValid = isNone(soldOutValidUntil) || new Date(soldOutValidUntil) > new Date();
    return this.getUnitOverride(unit.token, 'sold_out') && soldOutIsValid;
  });
}), _dec86 = computed('composition.compositionType', function () {
  return this.composition?.compositionType === CompositionType.FIXED_COMPOSITION;
}), _class2 = (_class3 = class _class2 extends ItemsV3Base {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "userInfo", _descriptor2, this);
    _initializerDefineProperty(this, "features", _descriptor3, this);
    _initializerDefineProperty(this, "formatter", _descriptor4, this);
    _initializerDefineProperty(this, "name", _descriptor5, this);
    _initializerDefineProperty(this, "kitchenName", _descriptor6, this);
    _initializerDefineProperty(this, "ordinal", _descriptor7, this);
    _initializerDefineProperty(this, "price", _descriptor8, this);
    _initializerDefineProperty(this, "priceDescription", _descriptor9, this);
    _initializerDefineProperty(this, "pricingType", _descriptor10, this);
    _initializerDefineProperty(this, "customAttributes", _descriptor11, this);
    _initializerDefineProperty(this, "item", _descriptor12, this);
    // Service variation properties
    _initializerDefineProperty(this, "appointmentEmployees", _descriptor13, this);
    _initializerDefineProperty(this, "noShowFee", _descriptor14, this);
    _initializerDefineProperty(this, "noShowFeePercentage", _descriptor15, this);
    _initializerDefineProperty(this, "serviceCostFlat", _descriptor16, this);
    _initializerDefineProperty(this, "serviceCostPercentage", _descriptor17, this);
    _initializerDefineProperty(this, "onlineBookingAvailable", _descriptor18, this);
    _initializerDefineProperty(this, "serviceDuration", _descriptor19, this);
    _initializerDefineProperty(this, "transitionTime", _descriptor20, this);
    _initializerDefineProperty(this, "resources", _descriptor21, this);
    _initializerDefineProperty(this, "intermissions", _descriptor22, this);
    // Non-service variation properties
    _initializerDefineProperty(this, "inventoryAvailabilityRule", _descriptor23, this);
    _initializerDefineProperty(this, "fractionalInventoryInStockCount", _descriptor24, this);
    _initializerDefineProperty(this, "fractionalInventoryAvailableCount", _descriptor25, this);
    _initializerDefineProperty(this, "fractionalInventoryCommittedCount", _descriptor26, this);
    _initializerDefineProperty(this, "gtin", _descriptor27, this);
    _initializerDefineProperty(this, "inventoryAlertThreshold", _descriptor28, this);
    _initializerDefineProperty(this, "inventoryAlertType", _descriptor29, this);
    _initializerDefineProperty(this, "inventoryInStockCount", _descriptor30, this);
    _initializerDefineProperty(this, "sku", _descriptor31, this);
    _initializerDefineProperty(this, "trackInventory", _descriptor32, this);
    _initializerDefineProperty(this, "soldOut", _descriptor33, this);
    _initializerDefineProperty(this, "soldOutValidUntil", _descriptor34, this);
    _initializerDefineProperty(this, "sellable", _descriptor35, this);
    _initializerDefineProperty(this, "stockable", _descriptor36, this);
    _initializerDefineProperty(this, "itemVariationVendorInfos", _descriptor37, this);
    _initializerDefineProperty(this, "components", _descriptor38, this);
    _initializerDefineProperty(this, "composition", _descriptor39, this);
    _initializerDefineProperty(this, "ingredients", _descriptor40, this);
    _initializerDefineProperty(this, "recipe", _descriptor41, this);
    _initializerDefineProperty(this, "salePrices", _descriptor42, this);
    _initializerDefineProperty(this, "effectiveSalePrice", _descriptor43, this);
    _initializerDefineProperty(this, "imageMemberships", _descriptor44, this);
    _initializerDefineProperty(this, "channels", _descriptor45, this);
    _initializerDefineProperty(this, "imageSortProperties", _descriptor46, this);
    _initializerDefineProperty(this, "sortedImageMemberships", _descriptor47, this);
    _initializerDefineProperty(this, "images", _descriptor48, this);
    _initializerDefineProperty(this, "primaryImage", _descriptor49, this);
    _initializerDefineProperty(this, "weightAmount", _descriptor50, this);
    _initializerDefineProperty(this, "weightUnit", _descriptor51, this);
    // For CREDIT_PACKAGE ItemVariations
    _initializerDefineProperty(this, "creditsValidityDuration", _descriptor52, this);
    _initializerDefineProperty(this, "creditRedemptionPolicies", _descriptor53, this);
    // For legacy purposes, undefined stockable attribute is considered true
    _initializerDefineProperty(this, "isStockable", _descriptor54, this);
    // For legacy purposes, undefined sellable attribute is considered true
    _initializerDefineProperty(this, "isSellable", _descriptor55, this);
    /* Determines if the item variation is a sell by variation
     * From server eng design:
     * Sell-by relationships are defined as:
     *  - 1-to-1 component-composition relation
     *  - component variation and composition variation both share the same parent item
     *  - the component variation is stockable
     */
    _initializerDefineProperty(this, "isSellByVariation", _descriptor56, this);
    _initializerDefineProperty(this, "derivedSellByVariations", _descriptor57, this);
    _initializerDefineProperty(this, "compositionVariations", _descriptor58, this);
    _initializerDefineProperty(this, "ingredientVariations", _descriptor59, this);
    /**
     * Sellable variations related to this variation. Can include itself
     */
    _initializerDefineProperty(this, "sellableVariations", _descriptor60, this);
    /**
     * Sellable variations related to this variation. Can include itself. Does not inculde variatons marked as not for sale
     */
    _initializerDefineProperty(this, "variationsForSale", _descriptor61, this);
    /**
     * variation with no units for sale
     */
    _initializerDefineProperty(this, "isNotForSale", _descriptor62, this);
    _initializerDefineProperty(this, "itemOptionValues", _descriptor63, this);
    // note(cclegg): This attribute is used to save the item option ids sent from the server and send them back unchanged on save if
    // related item options and values aren't fetched or edited. If the option values on the variation _are_ fetched
    // and changed then these ids will be overridden by the new values during serialization (see this model's serializer).
    // No need to manually update this property.
    _initializerDefineProperty(this, "itemOptionIds", _descriptor64, this);
    _initializerDefineProperty(this, "measurementUnit", _descriptor65, this);
    _initializerDefineProperty(this, "hasDirtyGtin", _descriptor66, this);
    _initializerDefineProperty(this, "nameCommaSku", _descriptor67, this);
    _initializerDefineProperty(this, "defaultVendor", _descriptor68, this);
    _initializerDefineProperty(this, "defaultCost", _descriptor69, this);
    _initializerDefineProperty(this, "isVariablePriced", _descriptor70, this);
    _initializerDefineProperty(this, "formattedInclusiveTaxEstimate", _descriptor71, this);
    _initializerDefineProperty(this, "formattedPrice", _descriptor72, this);
    _initializerDefineProperty(this, "priceRange", _descriptor73, this);
    _initializerDefineProperty(this, "priceRangeWithUnit", _descriptor74, this);
    _initializerDefineProperty(this, "lowInventorySubunitTokens", _descriptor75, this);
    _initializerDefineProperty(this, "outOfStockSubunitTokens", _descriptor76, this);
    _initializerDefineProperty(this, "itemOptionValuesByOptionId", _descriptor77, this);
    _initializerDefineProperty(this, "isSoldOutAllLocations", _descriptor78, this);
    _initializerDefineProperty(this, "isSoldOutAnyLocation", _descriptor79, this);
    _initializerDefineProperty(this, "isBundle", _descriptor80, this);
  }
  static catalogType() {
    return 'ITEM_VARIATION';
  }
  static createDefaultOptions() {
    return {
      pricingType: PricingType.VARIABLE_PRICING
    };
  }
  static createDefault(store, merchantSubunits = null, globallyEnabled = false, item = null) {
    const application = getOwner(store);
    const intl = application.lookup('service:intl');
    const options = this.createDefaultOptions();
    options.ordinal = 1;
    options.name = intl.t('items.newItemVariationName');
    const variation = store.createRecord('item-variation', options);
    const disabledUnits = isNone(item) ? [] : item.get('disabledUnits');
    if (!isNone(merchantSubunits)) {
      variation.setMerchantSubunits(merchantSubunits, null, disabledUnits);
    }
    variation.set('globallyEnabled', globallyEnabled);
    if (item) {
      item.watchRelationship('itemVariations', () => {
        variation.set('item', item);
      });
    }
    return variation;
  }
  static createDefaultForDonation(store, merchantSubunits = null, globallyEnabled = false, item = null) {
    const application = getOwner(store);
    const intl = application.lookup('service:intl');
    const defaultDonationAmounts = [{
      name: Money.fromCents(1000).formatted,
      price: Money.fromCents(1000),
      pricingType: PricingType.FIXED_PRICING,
      ordinal: 0
    }, {
      name: Money.fromCents(2000).formatted,
      price: Money.fromCents(2000),
      pricingType: PricingType.FIXED_PRICING,
      ordinal: 1
    }, {
      name: Money.fromCents(5000).formatted,
      price: Money.fromCents(5000),
      pricingType: PricingType.FIXED_PRICING,
      ordinal: 2
    }, {
      name: Money.fromCents(10000).formatted,
      price: Money.fromCents(10000),
      pricingType: PricingType.FIXED_PRICING,
      ordinal: 3
    }, {
      name: intl.t('items.itemLibrary.edit.donationDetails.customAmount'),
      pricingType: PricingType.VARIABLE_PRICING,
      ordinal: 4
    }];
    const donationVariations = defaultDonationAmounts.map(donation => {
      const variation = store.createRecord('item-variation', donation);
      const disabledUnits = isNone(item) ? [] : item.get('disabledUnits');
      if (!isNone(merchantSubunits)) {
        variation.setMerchantSubunits(merchantSubunits, null, disabledUnits);
      }
      variation.set('globallyEnabled', globallyEnabled);
      return variation;
    });
    return donationVariations;
  }
  init(...args) {
    super.init(...args);
    if (!this.isDestroyed && !this.isDestroying && this.isNew && this.item) {
      const enabledUnits = this.item.get('subunits');
      const disabledUnits = this.item.get('disabledUnits');
      this.setMerchantSubunits(enabledUnits, null, disabledUnits);
      set(this, 'globallyEnabled', this.item.get('globallyEnabled'));
    }
  }
  get hasValidServiceCostPercentage() {
    return this.serviceCostPercentage >= 0 && this.serviceCostPercentage <= 100;
  }
  get hasValidServiceCostFlat() {
    return this.pricingType === 'VARIABLE_PRICING' || this.pricingType === 'FIXED_PRICING' && this.price !== null && this.price.amount >= this.serviceCostFlat.amount;
  }
  get isDirty() {
    if (this.belongsTo('measurementUnit').value()?.isDirty || this.belongsTo('composition').value()?.isDirty || this.belongsTo('recipe').value()?.isDirty || (this.itemVariationVendorInfos || []).toArray().some(o => o && o.isDirty) || (this.components || []).toArray().some(o => o.isDirty) || (this.salePrices || []).toArray().some(o => o.isDirty)) {
      return true;
    }
    return super.isDirty;
  }
  rollbackRelationships() {
    super.rollbackRelationships();
    this.components?.forEach(o => o.rollbackRelationships());
    this.composition?.rollbackRelationships();
    this.recipe?.rollbackRelationships();
  }
  rollbackAttributes(rollbackRelationships = true) {
    super.rollbackAttributes();
    if (rollbackRelationships) {
      this.components?.forEach(component => component.rollbackAttributes());
      this.composition?.rollbackAttributes();
      this.recipe?.rollbackAttributes();
    }
  }
  get vendors() {
    if (this._vendorsOverride) {
      return this._vendorsOverride;
    }
    return this.itemVariationVendorInfos.rejectBy('isDeleted').mapBy('vendor').compact();
  }
  set vendors(value) {
    set(this, '_vendorsOverride', value);
  }
  get defaultItemVariationVendorInfo() {
    if (this._defaultItemVariationVendorInfo !== undefined) {
      return this._defaultItemVariationVendorInfo;
    }
    const vendorInfos = this.itemVariationVendorInfos.rejectBy('isDeleted');
    if (vendorInfos.get('length') === 0) {
      return null;
    }
    return vendorInfos.sortBy('ordinal').get('firstObject');
  }
  set defaultItemVariationVendorInfo(value) {
    set(this, '_defaultItemVariationVendorInfo', value);
  }
  getCostForVendor(vendor) {
    const vendorInfo = this.itemVariationVendorInfos.findBy('vendor', vendor);
    if (!isNone(vendorInfo)) {
      return vendorInfo.get('price');
    } else {
      return this.defaultCost;
    }
  }
  // getPricesInfoForUnits checks prices data for units and returns an object with
  // three fields:
  // - description: when the variation is free or variable priced, description will
  // be populated with internationalized merchant facing value.
  // - price: populated when the variation has a single price for units.
  // - prices: populated when the variation has multiple prices. sorted.
  getPricesInfoForUnits(units) {
    const prices = A();
    let isVariable = false;
    let isFree = true;
    let hasUnitWithoutOverrides = isEmpty(units);
    units.forEach(unit => {
      const price = this.getUnitOverride(unit.get('token'), 'price');
      const pricingType = this.getUnitOverride(unit.get('token'), 'pricing_type');
      if (!isNone(pricingType)) {
        if (pricingType === PricingType.serialize(PricingType.VARIABLE_PRICING)) {
          isVariable = true;
          isFree = false;
        } else if (isNone(price)) {
          hasUnitWithoutOverrides = true;
        } else {
          const cents = price.cents;
          // if any override is variable we simply show Variable
          if (isNone(cents)) {
            isVariable = true;
          } else if (cents > 0) {
            isFree = false;
          }
          const currencyCode = price.currency_code || this.userInfo.currencyCode;
          prices.addObject(Money.fromCents(cents, currencyCode));
        }
      } else {
        hasUnitWithoutOverrides = true;
      }
    });
    if (hasUnitWithoutOverrides) {
      if (this.isVariablePriced) {
        return {
          description: this.intl.t('items.displayPrice.variable')
        };
      } else if (this.price.amount > 0) {
        isFree = false;
      }
      prices.addObject(this.price);
    }
    if (isVariable || isEmpty(prices)) {
      return {
        description: this.intl.t('items.displayPrice.variable')
      };
    } else if (isFree) {
      return {
        description: this.intl.t('items.displayPrice.free')
      };
    }
    const sortedPrices = A(prices.sortBy('amount'));
    if (sortedPrices.firstObject.equals(sortedPrices.lastObject)) {
      return {
        price: sortedPrices.firstObject
      };
    } else {
      return {
        prices: sortedPrices
      };
    }
  }
  getPriceRangeForUnits(units) {
    const pricesInfo = this.getPricesInfoForUnits(units);
    if (!isEmpty(pricesInfo.description)) {
      return pricesInfo.description;
    } else if (!isNone(pricesInfo.price)) {
      return pricesInfo.price.formatted;
    } else {
      return `${pricesInfo.prices.firstObject.formatted} - ${pricesInfo.prices.lastObject.formatted}`;
    }
  }
  inventoryTrackingEnabledAtSubunit(unitToken) {
    // Respect unit override first if there is an override.
    // If not, return the global trackInventory attribute
    const trackInventoryUnitOverride = this.getUnitOverride(unitToken, 'track_inventory');
    if (!isNone(trackInventoryUnitOverride)) {
      return trackInventoryUnitOverride;
    }
    return Boolean(this.trackInventory);
  }
  inventoryAlertsEnabledAtSubunit(unitToken) {
    return this.getUnitOverride(unitToken, 'inventory_alert_type') === 2;
  }
  inventoryTrackingAndAlertsEnabledAtSubunit(unitToken) {
    return this.inventoryTrackingEnabledAtSubunit(unitToken) && this.inventoryAlertsEnabledAtSubunit(unitToken);
  }
  inventoryIsLowAtSubunit(unitToken) {
    const alertThreshold = new DecimalStockCount({
      _integer: this.getUnitOverride(unitToken, 'inventory_alert_threshold') || 0
    });
    if (this.inventoryTrackingAndAlertsEnabledAtSubunit(unitToken)) {
      const inStock = DecimalStockCount.fromString(this.getUnitOverride(unitToken, 'fractional_inventory_in_stock_count') || '0');
      if (inStock.gt(DecimalStockCount.zero()) && inStock.lte(alertThreshold)) {
        return true;
      }
    }
    return false;
  }
  inventoryIsOutAtSubunit(unitToken) {
    if (this.inventoryTrackingAndAlertsEnabledAtSubunit(unitToken)) {
      const inStock = DecimalStockCount.fromString(this.getUnitOverride(unitToken, 'fractional_inventory_in_stock_count') || '0');
      if (inStock.lte(DecimalStockCount.zero())) {
        return true;
      }
    }
    return false;
  }
  hasStockAtAnyEnabledSubunit() {
    return this.subunits.any(subunit => {
      return this.getFractionalInventoryStockCountForUnits([subunit]) > 0;
    });
  }
  // NOTE (rglazerman): we don't just run this on this.get("subunits") because we want to potentially
  // include units where the variation is disabled but has a stock count for transfer purposes.
  anyUnitHasStockCount(units) {
    return units.any(unit => {
      return this.unitHasStockCount(unit);
    });
  }
  unitHasStockCount(unit) {
    return isPresent(this.getUnitOverride(unit.get('token'), 'fractional_inventory_in_stock_count'));
  }
  getFractionalInventoryStockCountForUnits(units) {
    const unitCounts = units.map(unit => this.getFractionalInventoryStockCountForUnitToken(unit.get('token'))).compact();
    if (unitCounts.length === 0) {
      return null;
    }
    return unitCounts.reduce((a, b) => a.add(b) || a, DecimalStockCount.zero());
  }
  getFractionalInventoryStockCountForUnitToken(unitToken, ignoreTracking = false) {
    if (this.inventoryTrackingEnabledAtSubunit(unitToken) || ignoreTracking) {
      let overrideQuantity = this.getUnitOverride(unitToken, TEMP_FRACTIONAL_INVENTORY_IN_STOCK_COUNT);
      if (isEmpty(overrideQuantity)) {
        overrideQuantity = this.getUnitOverride(unitToken, 'fractional_inventory_in_stock_count') || '0';
      }
      return DecimalStockCount.fromString(overrideQuantity);
    }
    return null;
  }
  getFractionalInventoryCommittedCountForUnitToken(unitToken, ignoreTracking = false) {
    if (this.inventoryTrackingEnabledAtSubunit(unitToken) || ignoreTracking) {
      return DecimalStockCount.fromString(this.getUnitOverride(unitToken, 'fractional_inventory_committed_count') || '0');
    }
    return null;
  }
  getFractionalInventoryAvailableCountForUnitToken(unitToken, ignoreTracking = false) {
    if (this.inventoryTrackingEnabledAtSubunit(unitToken) || ignoreTracking) {
      let overrideQuantity = this.getUnitOverride(unitToken, TEMP_FRACTIONAL_INVENTORY_AVAILABLE_COUNT);
      if (isEmpty(overrideQuantity)) {
        overrideQuantity = this.getUnitOverride(unitToken, 'fractional_inventory_available_count') || '0';
      }
      return DecimalStockCount.fromString(overrideQuantity);
    }
    return null;
  }
  fractionalInventoryStockCountsByUnitToken(ignoreTracking = false) {
    const fractionalInventoryStockCountByUnit = {};
    this.effectiveEnabledUnits.forEach(unit => {
      fractionalInventoryStockCountByUnit[unit.token] = this.getFractionalInventoryStockCountForUnitToken(unit.token, ignoreTracking);
    });
    return fractionalInventoryStockCountByUnit;
  }
  makeTempInventoryStockCountsReal(subunits) {
    subunits.forEach(unit => {
      const unitToken = unit.get('token');

      // This is safe to do without the feature flag and saves us from having to pass the flag into the function
      const fractionalQuantity = this.getUnitOverride(unitToken, TEMP_FRACTIONAL_INVENTORY_IN_STOCK_COUNT);
      this.setUnitOverride(unitToken, 'fractional_inventory_in_stock_count', fractionalQuantity);
      this.removeUnitOverride(unitToken, TEMP_FRACTIONAL_INVENTORY_IN_STOCK_COUNT);
      const fractionalAvailableQuantity = this.getUnitOverride(unitToken, TEMP_FRACTIONAL_INVENTORY_AVAILABLE_COUNT);
      this.setUnitOverride(unitToken, 'fractional_inventory_available_count', fractionalAvailableQuantity);
      this.removeUnitOverride(unitToken, TEMP_FRACTIONAL_INVENTORY_AVAILABLE_COUNT);
    });
  }
  // eslint-disable-next-line ember/no-observers
  _adjustPricingType() {
    if (!isNone(this.price?.amount)) {
      if (this.pricingType !== PricingType.FIXED_PRICING) {
        set(this, 'pricingType', PricingType.FIXED_PRICING);
      }
    } else if (this.pricingType !== PricingType.VARIABLE_PRICING && !this.item?.isDonation) {
      set(this, 'pricingType', PricingType.VARIABLE_PRICING);

      // Dashboard currently does not handle pricing type unit overrides correctly. It will never read/write a pricing type unit override.
      // This "works" because POS will ignore pricing type if there is a price, so setting the override pricing type doesn't matter. However, if a price
      // override is created on POS it will have a "FIXED_PRICING" override created. If that override is deleted on dashboard the price override will be deleted but the
      // pricing type override is not deleted, causing a save error only when the merchant attempts to set the global pricing type to variable.
      // See ONCALL-57764 for example. We should refactor how dashboard handles pricing type overrides, but this check is necessary to fix previously broken data.
      const unitOverrides = this.unitOverrides;
      Object.keys(unitOverrides).forEach(unit => {
        const pricingType = this.getUnitOverride(unit, 'pricing_type');
        const price = this.getUnitOverride(unit, 'price');
        if (PricingType.values[pricingType] === PricingType.FIXED_PRICING && isNone(price)) {
          this.removeUnitOverride(unit, 'pricing_type');
        }
      });
    }
  }
  hasResourceForUnit(resource, unit) {
    if (isNone(resource) || isNone(unit)) {
      return false;
    }
    return (this.resources || []).toArray().some(membership => {
      return membership.unit.token === unit.token && membership.resourceId === resource.id;
    });
  }
  resourcesForUnit(unit) {
    if (isNone(unit)) {
      return [];
    }
    return this.resources.filterBy('unit.token', unit.token).mapBy('resource');
  }
  addResourceForUnit(resource, unit) {
    if (isNone(resource) || isNone(unit) || this.hasResourceForUnit(resource, unit)) {
      return null;
    }
    const membership = this.store.createFragment('resource-membership', {
      resourceId: resource.idOrTempId(),
      unitToken: unit.token
    });
    return this.resources.pushObject(membership);
  }
  removeResourceForUnit(resource, unit) {
    if (isNone(resource) || isNone(unit)) {
      return null;
    }
    const resourceToBeRemoved = this.resources.find(membership => {
      return membership.unit.token === unit.token && membership.resourceId === resource.id;
    });
    if (isNone(resourceToBeRemoved)) {
      return null;
    }
    return this.resources.removeObject(resourceToBeRemoved);
  }
  removeAllResources() {
    return set(this, 'resources', []);
  }
  addResources(resources) {
    this.resources.addObjects(resources);
  }
  updateEffectiveSalePrice(price) {
    if (isPresent(this.effectiveSalePrice)) {
      this.effectiveSalePrice.set('price', price);
      return;
    }
    const salePrice = this.store.createRecord('sale-price', {
      itemVariationId: this.idOrTempId(),
      price
    });
    this.salePrices.addObject(salePrice);
  }
  deleteEmptySalePrices() {
    this.salePrices.filter(salePrice => isNone(salePrice.price?.amount)).forEach(salePrice => {
      salePrice.deleteRecord();
    });
  }
}, _defineProperty(_class3, "_modelNameForMigration", 'item-variation'), _defineProperty(_class3, "PricingType", PricingType), _defineProperty(_class3, "sortKey", 'name'), _class3), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "intl", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "userInfo", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "features", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "formatter", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "kitchenName", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "ordinal", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "price", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "priceDescription", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "pricingType", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "customAttributes", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "item", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "appointmentEmployees", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "noShowFee", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "noShowFeePercentage", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, "serviceCostFlat", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, "serviceCostPercentage", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, "onlineBookingAvailable", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, "serviceDuration", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class2.prototype, "transitionTime", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class2.prototype, "resources", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class2.prototype, "intermissions", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class2.prototype, "inventoryAvailabilityRule", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class2.prototype, "fractionalInventoryInStockCount", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class2.prototype, "fractionalInventoryAvailableCount", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class2.prototype, "fractionalInventoryCommittedCount", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class2.prototype, "gtin", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class2.prototype, "inventoryAlertThreshold", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class2.prototype, "inventoryAlertType", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class2.prototype, "inventoryInStockCount", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class2.prototype, "sku", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class2.prototype, "trackInventory", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class2.prototype, "soldOut", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class2.prototype, "soldOutValidUntil", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class2.prototype, "sellable", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class2.prototype, "stockable", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class2.prototype, "itemVariationVendorInfos", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class2.prototype, "components", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class2.prototype, "composition", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class2.prototype, "ingredients", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class2.prototype, "recipe", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class2.prototype, "salePrices", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class2.prototype, "effectiveSalePrice", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class2.prototype, "imageMemberships", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class2.prototype, "channels", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class2.prototype, "imageSortProperties", [_dec46], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class2.prototype, "sortedImageMemberships", [_dec47], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class2.prototype, "images", [_dec48], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class2.prototype, "primaryImage", [_dec49], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class2.prototype, "weightAmount", [_dec50], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class2.prototype, "weightUnit", [_dec51], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class2.prototype, "creditsValidityDuration", [_dec52], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class2.prototype, "creditRedemptionPolicies", [_dec53], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class2.prototype, "isStockable", [_dec54], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class2.prototype, "isSellable", [_dec55], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class2.prototype, "isSellByVariation", [_dec56], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "hasValidServiceCostPercentage", [_dec57], Object.getOwnPropertyDescriptor(_class2.prototype, "hasValidServiceCostPercentage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasValidServiceCostFlat", [_dec58], Object.getOwnPropertyDescriptor(_class2.prototype, "hasValidServiceCostFlat"), _class2.prototype), _descriptor57 = _applyDecoratedDescriptor(_class2.prototype, "derivedSellByVariations", [_dec59], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = _applyDecoratedDescriptor(_class2.prototype, "compositionVariations", [_dec60], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor59 = _applyDecoratedDescriptor(_class2.prototype, "ingredientVariations", [_dec61], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor60 = _applyDecoratedDescriptor(_class2.prototype, "sellableVariations", [_dec62], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor61 = _applyDecoratedDescriptor(_class2.prototype, "variationsForSale", [_dec63], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor62 = _applyDecoratedDescriptor(_class2.prototype, "isNotForSale", [_dec64], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor63 = _applyDecoratedDescriptor(_class2.prototype, "itemOptionValues", [_dec65], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor64 = _applyDecoratedDescriptor(_class2.prototype, "itemOptionIds", [_dec66], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor65 = _applyDecoratedDescriptor(_class2.prototype, "measurementUnit", [_dec67], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "isDirty", [_dec68], Object.getOwnPropertyDescriptor(_class2.prototype, "isDirty"), _class2.prototype), _descriptor66 = _applyDecoratedDescriptor(_class2.prototype, "hasDirtyGtin", [_dec69], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor67 = _applyDecoratedDescriptor(_class2.prototype, "nameCommaSku", [_dec70], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "vendors", [_dec71], Object.getOwnPropertyDescriptor(_class2.prototype, "vendors"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "defaultItemVariationVendorInfo", [_dec72], Object.getOwnPropertyDescriptor(_class2.prototype, "defaultItemVariationVendorInfo"), _class2.prototype), _descriptor68 = _applyDecoratedDescriptor(_class2.prototype, "defaultVendor", [_dec73], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor69 = _applyDecoratedDescriptor(_class2.prototype, "defaultCost", [_dec74], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor70 = _applyDecoratedDescriptor(_class2.prototype, "isVariablePriced", [_dec75], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor71 = _applyDecoratedDescriptor(_class2.prototype, "formattedInclusiveTaxEstimate", [_dec76], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor72 = _applyDecoratedDescriptor(_class2.prototype, "formattedPrice", [_dec77], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor73 = _applyDecoratedDescriptor(_class2.prototype, "priceRange", [_dec78], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor74 = _applyDecoratedDescriptor(_class2.prototype, "priceRangeWithUnit", [_dec79], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor75 = _applyDecoratedDescriptor(_class2.prototype, "lowInventorySubunitTokens", [_dec80], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor76 = _applyDecoratedDescriptor(_class2.prototype, "outOfStockSubunitTokens", [_dec81], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor77 = _applyDecoratedDescriptor(_class2.prototype, "itemOptionValuesByOptionId", [_dec82], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "_adjustPricingType", [_dec83], Object.getOwnPropertyDescriptor(_class2.prototype, "_adjustPricingType"), _class2.prototype), _descriptor78 = _applyDecoratedDescriptor(_class2.prototype, "isSoldOutAllLocations", [_dec84], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor79 = _applyDecoratedDescriptor(_class2.prototype, "isSoldOutAnyLocation", [_dec85], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor80 = _applyDecoratedDescriptor(_class2.prototype, "isBundle", [_dec86], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export { _class as default };